import { FC } from 'react';

import {
    Card,
    Flex,
    FullPageContainer,
    Loader,
    Table,
    TableBody,
    Text,
    useBreakpoint,
    VSpacing,
} from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { UsersTableHeader } from 'components/Admin/Users/UsersTable/UsersTableHeader';
import { UsersTableRow } from 'components/Admin/Users/UsersTable/UsersTableRow';

import { useSelector } from 'store/utils';

const TrlKeys = {
    notFound: 'admin.Users.UsersTable.notFound',
    unavailableOnMobile: 'admin.Users.UsersTable.unavailableOnMobile',
};

export const UsersTable: FC = () => {
    const { isLoad, users } = useSelector((state) => state.users);

    const { isMobile } = useBreakpoint();
    const trls = useTrls();

    if (isLoad) {
        return (
            <>
                <VSpacing default={24} />
                <Flex justify="center">
                    <Loader size={32} />
                </Flex>
            </>
        );
    }

    if (users.length === 0) {
        return (
            <>
                <VSpacing default={24} />
                <Text style="secondary">{trls(TrlKeys.notFound)}</Text>
            </>
        );
    }

    if (isMobile) {
        return (
            <>
                <VSpacing default={24} />
                <Text style="secondary">{trls(TrlKeys.unavailableOnMobile)}</Text>
            </>
        );
    }

    return (
        <>
            <VSpacing default={16} />
            <FullPageContainer>
                {({ paddingLeft, paddingRight }) => (
                    <Card stretched>
                        <Table
                            divider
                            paddingLeft={paddingLeft}
                            paddingRight={paddingRight}
                            density={12}
                            data-qa="users-table"
                        >
                            <UsersTableHeader />
                            <TableBody>
                                {users.map((user) => (
                                    <UsersTableRow key={user.id} {...user} />
                                ))}
                            </TableBody>
                        </Table>
                    </Card>
                )}
            </FullPageContainer>
        </>
    );
};
